import React from 'react';
import './Skeleton.css';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  variant?: 'text' | 'rect' | 'circle';
  className?: string;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({ 
  width = '100%', 
  height = 20, 
  variant = 'rect',
  className = '',
  style = {}
}) => {
  const getVariantStyles = (): React.CSSProperties => {
    switch (variant) {
      case 'circle':
        return {
          borderRadius: '50%',
          width: typeof width === 'number' ? width : parseInt(width),
          height: typeof width === 'number' ? width : parseInt(width), // Make it square for circle
        };
      case 'text':
        return {
          borderRadius: '4px',
          height: 16,
        };
      default:
        return {
          borderRadius: '4px',
        };
    }
  };

  return (
    <div 
      className={`skeleton-loader ${className}`}
      style={{
        width,
        height,
        ...getVariantStyles(),
        ...style
      }}
    />
  );
};

export default Skeleton;